import React from 'react';
import styles from './AdStatus.module.scss';
import {IProduct} from 'data/interfaces/products';
import {
  PRODUCT_STATUS_CANCELED,
  PRODUCT_STATUS_DISAPPROVED,
  PRODUCT_STATUS_ORDER,
  PRODUCT_STATUS_ORDER_APPROVED_TRANSFERRED,
  PRODUCT_STATUS_ORDER_APPROVED_WAITING_PAYMENT,
  PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER,
  PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER_APPROVAL_BY_BUYER,
  PRODUCT_STATUS_ORDER_DISPUTE,
  PRODUCT_STATUS_ORDER_SOLD,
  PRODUCT_STATUS_PUBLISHED,
  PRODUCT_STATUS_TIMED_OUT,
  PRODUCT_STATUS_UNKNOWN,
  PRODUCT_STATUS_WAITING_FOR_APPROVAL
} from 'data/redux/constants/productsConstants';
import {IOrder} from 'data/interfaces/orders';
import {When} from 'react-if';
import HistoryRoundedIcon from '@material-ui/icons/HistoryRounded';

interface IAdStatusProps {
  product: IProduct;
  order: IOrder;
  statusToText?: (status: number) => any;
  status?: number;
  style?: any;
  statusStyle?: any;
}

export const statusToText = (status) => {
  switch (status) {
    case PRODUCT_STATUS_UNKNOWN:
      return "לא ידוע";
    case PRODUCT_STATUS_WAITING_FOR_APPROVAL:
      return "מודעה חדשה ממתינה לאישור פרסום";
    case PRODUCT_STATUS_DISAPPROVED:
      return "מודעה לא מאושרת לפרסום";
    case PRODUCT_STATUS_PUBLISHED:
      return "מודעה מפורסמת";
    case PRODUCT_STATUS_CANCELED:
      return "מודעה מבוטלת";
    case PRODUCT_STATUS_TIMED_OUT:
      return "מודעה שזמנה נגמר";
    case PRODUCT_STATUS_ORDER:
      return "מודעה עם הצעה לקנייה";
    case PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER:
      return "מודעה ממתינה לצירוף מסמכים";
    case PRODUCT_STATUS_ORDER_APPROVED_TRANSFERRED:
      return "מודעה בתהליך תשלום";
    case PRODUCT_STATUS_ORDER_APPROVED_WAITING_PAYMENT:
      return "מודעה שנרכשה וממתין להעברה כספית";
    case PRODUCT_STATUS_ORDER_SOLD:
      return "מודעה  שנמכרה בהצלחה";
    case PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER_APPROVAL_BY_BUYER:
      return "מודעה ממתינה לאישור הקונה";
    case PRODUCT_STATUS_ORDER_DISPUTE:
      return "מודעה במחלוקת";
  }
}


const statusAppendTemplate = (status: number): any => {
  switch (status) {
    case PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER:
    case PRODUCT_STATUS_ORDER_APPROVED_TRANSFERRED:
    case PRODUCT_STATUS_ORDER_APPROVED_WAITING_PAYMENT:
    case PRODUCT_STATUS_ORDER_APPROVED_WAITING_TRANSFER_APPROVAL_BY_BUYER:
    case PRODUCT_STATUS_ORDER_DISPUTE:
      return {text: statusToText(status), template: "waiting", rightIcon: <HistoryRoundedIcon/>};
    case PRODUCT_STATUS_DISAPPROVED:
    case PRODUCT_STATUS_CANCELED:
    case PRODUCT_STATUS_TIMED_OUT:
      return {text: statusToText(status), template: "disapproved"};
    case PRODUCT_STATUS_UNKNOWN:
      return {text: statusToText(status), template: "default"};
    case PRODUCT_STATUS_UNKNOWN:
    case PRODUCT_STATUS_WAITING_FOR_APPROVAL:
    case PRODUCT_STATUS_PUBLISHED:
    case PRODUCT_STATUS_ORDER:
    case PRODUCT_STATUS_ORDER_SOLD:
      return {text: statusToText(status), template: "approved"};
  }
}

const defaultSettings = {
  template: "default",
  text: '',
  rightIcon: null,
  leftIcon: null,
};
const AdStatus = (props: IAdStatusProps) => {
  const status = props.statusToText(props.product.status || props.order.status);
  const settings = {
    ...defaultSettings,
    text: (status && typeof status === 'string') ? status : defaultSettings.text,
    under: null,
    ...(status && typeof status === 'object' ? status : {}),
  };
  return (
    <span className={`AdStatusContainer ${styles.AdStatusContainer} ${settings.template}`}
          style={props.style}>
         <div className={styles.status} style={props.statusStyle}>
           <When condition={!!settings.rightIcon}>{() => <>
             {settings.rightIcon}
           </>}
           </When>
           {settings.text}
           <When condition={!!settings.leftIcon}>{() => <>
             {settings.leftIcon}
           </>}</When>
        </div>
    </span>
  );
};
AdStatus.defaultProps = {
  product: {},
  order: {},
  statusToText: statusAppendTemplate,
};
export default AdStatus;
